<template>
  <v-row justify="center" align="center" style="min-height: 70vh">
    <v-col cols="12">
      <div class="text-center mb-6 mb-sm-10">
        <div :class="tituloClass">¡Hola! Antes que nada contanos,</div>
        <div :class="tituloClass" class="mt-3">¿qué vas a registrar?</div>
      </div>
      <!-- Tarjeta Producto de Catálogo -->
      <v-row justify="center" align="center" class="mb-6">
        <!-- sm="6": en tablet las dos opciones lado a lado -->
        <v-col cols="12" sm="6" md="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="pa-4 pa-sm-6 text-center catalog-card"
              :elevation="hover ? 12 : 4"
              @click="
                $router.push({ name: 'empresa.productos.registrar.catalogo' })
              "
            >
              <v-icon size="48" color="blue">mdi-cart</v-icon>
              <h3 class="mt-3">Producto de Catálogo</h3>
              <p class="text-subtitle-2 text-center" style="color: #bdbdbd">
                Producto tangible, comprado a proveedor (ej. alfajor, bebida,
                snack)
              </p>
            </v-card>
          </v-hover>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="pa-4 pa-sm-6 text-center catalog-card"
              :elevation="hover ? 12 : 4"
              @click="
                $router.push({ name: 'empresa.productos.registrar.produccion' })
              "
            >
              <v-icon size="48" color="green">mdi-factory</v-icon>
              <h3 class="mt-3">Producto de Producción</h3>
              <p class="text-subtitle-2 text-center" style="color: #bdbdbd">
                Producto fabricado por tu empresa, como panificados, comidas,
                etc.
              </p>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ProductoEmpresaRegistrarSelector",
  computed: {
    tituloClass() {
      return this.$vuetify.breakpoint.xsOnly ? "text-h5" : "text-h4";
    },
  },
};
</script>

<style  scoped>
.catalog-card {
  cursor: pointer;
  border-radius: 12px;
  transition: all 0.3s ease;
}
.catalog-card:hover {
  transform: translateY(-4px);
}
</style>